function e(t, n) {
  return t instanceof Date ? new t.constructor(n) : new Date(n);
}
export {
  e as constructFrom,
  e as default
};
//# sourceMappingURL=constructFrom.js.map
